/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
'use strict'; // jshint ignore:line

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import '@/vendor/fontawesome/fontawesome-free-5.11.2-web/css/all.css';
// import 'bootstrap/dist/css/bootstrap.css';


import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

// import '@r/css/app.css';

new Vue({
   router,
   store,
   render: h => h(App)
}).$mount('#app');
